"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toSearchKey = exports.toSearchFilter = exports.toScript = exports.toGetTransactionsSearchKey = exports.toGetCellsSearchKey = void 0;
const toScript = data => ({
  code_hash: data.codeHash,
  hash_type: data.hashType,
  args: data.args
});
exports.toScript = toScript;
const toSearchFilter = data => {
  return {
    script: data.script ? toScript(data.script) : data.script,
    output_data_len_range: data.outputDataLenRange,
    output_capacity_range: data.outputCapacityRange,
    block_range: data.blockRange,
    script_len_range: data.scriptLenRange
  };
};
exports.toSearchFilter = toSearchFilter;
const toSearchKey = data => ({
  script: toScript(data.script),
  script_type: data.scriptType,
  filter: data.filter ? toSearchFilter(data.filter) : data.filter,
  script_search_mode: data.scriptSearchMode ? data.scriptSearchMode : "prefix"
});
exports.toSearchKey = toSearchKey;
const toGetCellsSearchKey = data => ({
  ...toSearchKey(data),
  with_data: data.withData
});
exports.toGetCellsSearchKey = toGetCellsSearchKey;
const toGetTransactionsSearchKey = data => ({
  ...toSearchKey(data),
  group_by_transaction: data.groupByTransaction
});
exports.toGetTransactionsSearchKey = toGetTransactionsSearchKey;
//# sourceMappingURL=paramsFormatter.js.map